// Default copy and image values that we want to allow customization for - not all strings need to
// be here for now. We can add more values as we want to allow greater customization.
export const defaultCopy = {
  completionWrapperValuePropAccountAgg:
    'Get a clear view of your spending, income, loans and more - all in one place.',
  // default value is null because there is no single default - setting this will override copy for
  // all flows and steps
  completionWrapperSidebarValueProp: null,

  yodleeSearchHeading: null,
  yodleeSearchSubheading: null,

  signinHeading: "Let's start by logging in to your NerdWallet account",
  registerHeading:
    'Get even more\nfinancial clarity with a\nNerdWallet account',

  creditScoreBasicInfoHeading:
    "You're just a few steps away from your credit score.",
  creditScoreFullInfoHeading: 'Looks like we need a few more details.',
  creditScoreInfoSubHeading:
    "And remember, checking your credit score won't impact it at all.",

  creditScoreShortSSNHeading: 'What are the last 4 digits of your SSN?',
  creditScoreShortSSNSubHeading:
    'Rest easy knowing this is only used to verify your identity.',

  creditScoreFullSSNHeading: 'What’s your full Social Security number?',
  creditScoreFullSSNSubHeading:
    'We couldn’t verify with the last four digits, so we need the full number.',

  creditScoreVerificationQuestionsHeading:
    'Finally, answer these questions to verify your ID.',

  otpPasscodeEntryHeading: 'Check your phone and enter your code below',
  otpPasscodeEntryError: 'That’s the wrong code, check it and try again.',
  otpPasscodeEntryRetry: 'Didn’t get it?',
  otpPasscodeEntryLink: 'Send another code',

  otpPasscodeEntryCtaText: 'Submit code',
  otpPhoneConfirmationHeading: 'We’ll text you a confirmation code',
  otpPhoneConfirmationSubHeading:
    'We’ll send a code to the number shown below to verify your identity.',
  otpPhoneConfirmationRetry: 'Didn’t get it?',
  otpPhoneConfirmationLink: 'Send another code',
  otpPhoneConfirmationCtaText: 'Send code',

  otpConfirmationStepHeading: 'How should we send your confirmation code?',
  otpConfirmationStepSubheading:
    'We’ll send a code to the number shown below to verify your identity.',
  otpConfirmationPhoneWarn: `Please make sure that the provided phone number is capable of receiving text messages. If
  you’d prefer to receive a code via a landline, select the 'phone call' option.`,
  otpConfirmationCtaText: 'Send code',

  alreadyUsedPhoneHeading:
    'This number has already been used to verify an account',
  alreadyUsedPhoneError:
    'A phone number can only be used to verify one account. ',
  alreadyUsedPhoneRetry: 'Update this number',
  alreadyUsedPhoneCtaText: 'Send Code',

  updatePhoneHeading: 'What’s your phone number?',
  updatePhoneSubHeading: 'We partner with TransUnion to verify your identity.',
  updatePhoneCta: 'Update Number',
};

export const defaultImages = {
  // default value is null because there is no single default - setting this will override image for
  // all flows and steps
  completionWrapperSidebarImage: null,
};
